import React from 'react';

const MenuIcon = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6667 3.33325H3.33333C2.8731 3.33325 2.5 3.70635 2.5 4.16659C2.5 4.62682 2.8731 4.99992 3.33333 4.99992H16.6667C17.1269 4.99992 17.5 4.62682 17.5 4.16659C17.5 3.70635 17.1269 3.33325 16.6667 3.33325Z" fill={color} />
    <path d="M16.6667 9.16675H3.33333C2.8731 9.16675 2.5 9.53984 2.5 10.0001C2.5 10.4603 2.8731 10.8334 3.33333 10.8334H16.6667C17.1269 10.8334 17.5 10.4603 17.5 10.0001C17.5 9.53984 17.1269 9.16675 16.6667 9.16675Z" fill={color} />
    <path d="M2.5 15.8333C2.5 15.3731 2.8731 15 3.33333 15H11.6667C12.1269 15 12.5 15.3731 12.5 15.8333C12.5 16.2936 12.1269 16.6667 11.6667 16.6667H3.33333C2.8731 16.6667 2.5 16.2936 2.5 15.8333Z" fill={color} />
  </svg>
);

export default MenuIcon;
